import getResizeImageUrl from 'helpers/media/getResizeImageUrl';

const getProfileHeroImages = (url, quality = null) => ({
  desktop: getResizeImageUrl(url, 540, 420, true, quality),
  mobile: getResizeImageUrl(url, 360, 'h', true, quality),
});

export default getProfileHeroImages;
